import { handleApiError } from "@/app/utils/handleApiError";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCountries } from "./countries.services";
import { CountriesResponse } from "./countries.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";

export const listCountries = createAsyncThunk<
  CountriesResponse,
  void,
  RejectValueType & { state: RootState }
>(
  "countries",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchCountries();
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { countries } = getState();
      if (countries.data && countries.data.length > 0) {
        return false;
      }
      if (countries.status === "loading") {
        return false;
      }
      return true;
    },
  },
);
